import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { submitTestimonyProgram } from '../../../Features/Learning/TestimonyProgram/Utils/TestimonyProgramUtils';
import { resetState, setField } from '../../../Features/Learning/TestimonyProgram/addTestimonyProgramSlice';
import Swal from 'sweetalert2';

const TestimonyProgramPost = ({ modal, toggle }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.addTestimonyProgram)
  const isUpdate = useSelector(state => state.addTestimonyProgram.isUpdate);
  const history = useNavigate();

  const handleSuccess = () => {
    dispatch(resetState());
    history(`${process.env.PUBLIC_URL}/testimony-program/`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let errorMessage = '';
    if (!isUpdate) {
      if (data.name === '' || data?.file?.length <= 0) {
        if (data.name === '') {
          errorMessage = 'Nama Group tidak boleh kosong.';
        } else if (data?.file?.length <= 0) {
          errorMessage = 'File tidak boleh kosong.';
        }
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: errorMessage,
        })
      } else {
        // console.log(data,'sukses data')
        dispatch(submitTestimonyProgram({ ...data, successCallback: handleSuccess }))
      }
    } else {
      if (data.name === '' || data?.file?.length <= 0) {
        if (data.name === '') {
          errorMessage = 'Nama Group tidak boleh kosong.';
        } else if (data?.file?.length <= 0) {
          errorMessage = 'File tidak boleh kosong.';
        }
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: errorMessage,
        })
      } else {
        // console.log(data,'sukses data')
        dispatch(submitTestimonyProgram({ ...data, successCallback: handleSuccess }))
      }
    }
  };

  // const handleDiscard = (e) => {
  //   e.preventDefault();
  //   dispatch(resetState());
  //   history(`${process.env.PUBLIC_URL}/testimony-program/`);
  // };

  // useEffect(() => {
  //   gapi.load('client', async () => {
  //     try {
  //       await gapi.client.init({
  //         apiKey: API_KEY,
  //         discoveryDocs: DISCOVERY_DOCS,
  //       });
  //       console.log('✅ GAPI client initialized (no auth2)');
  //       setGapiInitialized(true);
  //     } catch (error) {
  //       console.error('❌ Error initializing GAPI client:', error);
  //     }
  //   });
  // }, []);

  // // 🔘 Login & Picker
  // const handleLoginAndPickFile = () => {
  //   const client = window.google.accounts.oauth2.initTokenClient({
  //     client_id: process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID,
  //     scope: 'https://www.googleapis.com/auth/drive.readonly',
  //     callback: (response) => {
  //       if (response.access_token) {
  //         launchDrivePicker(response.access_token);
  //       } else {
  //         alert('❌ Gagal login');
  //       }
  //     },
  //   });

  //   client.requestAccessToken();
  // };

  // // 📁 Picker
  // const launchDrivePicker = (accessToken) => {
  //   gapi.load('picker', () => {
  //     const view = new window.google.picker.View(window.google.picker.ViewId.DOCS_IMAGES);
  //     const picker = new window.google.picker.PickerBuilder()
  //       .setAppId(process.env.REACT_APP_GOOGLE_DRIVE_PROJECT_NUMBER)
  //       .setOAuthToken(accessToken)
  //       .setDeveloperKey(process.env.REACT_APP_GOOGLE_DRIVE_API_KEY)
  //       .addView(view)
  //       .addView(new window.google.picker.DocsView(window.google.picker.ViewId.FOLDERS).setSelectFolderEnabled(true))
  //       .setCallback((data) => pickerCallback(data, accessToken))
  //       .build();
  //     picker.setVisible(true);
  //   });
  // };

  // // 📥 Callback setelah pilih file
  // const pickerCallback = async (data, accessToken) => {
  //   if (data.action === window.google.picker.Action.PICKED) {
  //     const file = data.docs[0];
  //     const fileId = file.id;

  //     try {
  //       setLoadingDriveFile(true);
  //       const metaRes = await fetch(
  //         `https://www.googleapis.com/drive/v3/files/${fileId}?fields=name,mimeType`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //           },
  //         }
  //       );

  //       if (!metaRes.ok) throw new Error('Metadata not found');

  //       const meta = await metaRes.json();
  //       const blobRes = await fetch(
  //         `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //           },
  //         }
  //       );

  //       const blob = await blobRes.blob();
  //       setDriveFile({ blob, name: meta.name });
  //       // alert(`✅ File "${meta.name}" berhasil diambil`);
  //       // if (meta.mimeType === 'application/pdf') {
  //       //   dispatch(setField({ field: 'link', value: `https://drive.google.com/file/d/${fileId}/preview` }));
  //       // } else {
  //       //   handleChangeStatus({ meta, file: blob }, 'done');
  //       // }
  //     } catch (err) {
  //       console.error('❌ Error:', err);
  //       alert('❌ Gagal mengambil file dari Google Drive.');
  //       setLoadingDriveFile(false);
  //     } finally {
  //       setLoadingDriveFile(false);
  //     }
  //   }
  // };

  return (
    <Fragment>
      {/* <Container fluid={true}>
        <Row>
          <Col sm="12">
            {startUpload ? (
              <Col lg="12">
                <div className="loader-box">
                  <Spinner attrSpinner={{ className: 'loader-30' }} />
                </div>
                <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Sedang proses unggah...'}</H6>
              </Col>
            ) : (
              <Card>
                <CardHeader className='pb-0'><H5>{isUpdate ? '' : 'Testimony Program Baru'}</H5></CardHeader>
                <CardBody className="add-post">
                  <TestimonyProgramForm gapiInitialized={gapiInitialized} handleLoginAndPickFile={handleLoginAndPickFile} loadingDriveFile={loadingDriveFile} driveFile={driveFile} setDriveFile={setDriveFile} isDropFile={isDropFile} setIsDropFile={setIsDropFile} />

                  <div className="btn-showcase text-end">
                    <Btn attrBtn={{ color: 'primary', type: 'submit', onClick: handleSubmit }}>{Post}</Btn>
                    <Btn attrBtn={{ color: 'light', type: 'reset', onClick: handleDiscard }}>{Discard}</Btn>
                  </div>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </Container> */}
      <Modal isOpen={modal} toggle={toggle} size='md' backdrop="static" keyboard={false} autoFocus>
        <ModalHeader toggle={toggle}>Tambah Group Testimoni</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="name">Nama Group</Label>
              <Input type="text" name="name" id="name" placeholder="Masukkan nama group testimoni" value={data?.name} onChange={(e) => dispatch(setField({ field: 'name', value: e.target.value }))} autoFocus />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default TestimonyProgramPost;